import { useEffect, useRef, useState } from 'react';

const STORAGE_KEY = 'bizy-greeting-impressions';
const INTRODUCTORY_THRESHOLD = 4;

export type GreetingVariant = 'introductory' | 'familiar' | 'canceled_admin' | 'canceled_non_admin';

function getImpressionCount(): number {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		return stored ? parseInt(stored, 10) || 0 : 0;
	} catch {
		return 0;
	}
}

function incrementImpressionCount(): number {
	const next = getImpressionCount() + 1;
	try {
		localStorage.setItem(STORAGE_KEY, String(next));
	} catch {
		// localStorage unavailable
	}
	return next;
}

export function getGreetingVariant(isCanceled: boolean, isAdmin: boolean, impressionCount: number): GreetingVariant {
	if (isCanceled) {
		return isAdmin ? 'canceled_admin' : 'canceled_non_admin';
	}
	return impressionCount < INTRODUCTORY_THRESHOLD ? 'introductory' : 'familiar';
}

export function useBizyGreeting(isVisible: boolean, isCanceled: boolean, isAdmin: boolean) {
	const [impressionCount, setImpressionCount] = useState(getImpressionCount);
	const hasCountedRef = useRef(false);

	useEffect(() => {
		if (isVisible && !hasCountedRef.current && !isCanceled) {
			hasCountedRef.current = true;
			incrementImpressionCount();
		}
		if (!isVisible) {
			hasCountedRef.current = false;
			setImpressionCount(getImpressionCount());
		}
	}, [isVisible, isCanceled]);

	const variant = getGreetingVariant(isCanceled, isAdmin, impressionCount);

	return { variant, impressionCount };
}
